module.exports = __webpack_public_path__ + "static/media/Sample-Listening-Short-Answer-Questons-trimmed.cae73fde.mp3";